<div *ngIf="turnOverSheet as toSheet else toLoading">
  <p-table #tosTable id="tosTable"
           [value]="toSheet"
           [rows]="rows"
           [loading]="loading"
           [rowsPerPageOptions]="[10,25,50,100]"
           [showCurrentPageReport]="true"
           [totalRecords]="totalTurnoverRecords"
           [paginator]="true"
           currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} документов"
           dataKey="DOCID"
           selectionMode="single"
           [(selection)]="selectedDocument"
           stateStorage="local"
           [stateKey]="state"
           rowExpandMode="single"
           (onStateSave)="onStateSave($event)"
           (onStateRestore)="onStateRestore($event)"
           [resizableColumns]="true"
           (onRowSelect)="onRowSelect($event)"
           (onRowUnselect)="onRowUnselect($event)"
           [rowHover]="true"
           styleClass="p-datatable p-datatable-gridlines p-datatable-striped">

    <ng-template pTemplate="caption" *ngIf="showCaption">
      <div class="flex flex-wrap align-items-center">
        <h3 class="ml-0 mr-auto" *ngIf="product">Оборотная ведомость по {{product.PRODCODE}} за {{depth}} месяцев</h3>

        <span class="mr-2 xl:col-2">
          <p-progressBar [value]="progress"></p-progressBar>
        </span>

        <span class="mr-2 xl:col-2" *ngIf="showDepthSelector">
          <h5>Загружать документы за {{depth}} месяцев</h5>
          <p-slider [(ngModel)]="depth" [min]="6" [max]="36" [step]="6" (onSlideEnd)="onSlideEnd($event)"></p-slider>
        </span>
        <p-button icon="pi pi-undo" label="Сбросить фильтр" class="mr-2" (onClick)="clearOrResetTableFilter($event)" pTooltip="Сбросить фильтр и вернуться в начало" tooltipPosition="top"></p-button>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th resizableColumns style="width: 3rem">...</th>
        <th pResizableColumn style="width: 5%">Документ <p-sortIcon field="DOCNAME"></p-sortIcon></th>
        <th pResizableColumn style="width: 9rem">Номер <p-sortIcon field="DOCNUMBER"></p-sortIcon></th>
        <th pResizableColumn style="width: 8rem">Дата <p-sortIcon field="DOCDATE"></p-sortIcon></th>

        <th pResizableColumn style="width: 10%">Склад <p-sortIcon field="DEPNAME"></p-sortIcon></th>
        <th pResizableColumn style="width: 100%">Контрагент <p-sortIcon field="CLINAME"></p-sortIcon></th>

        <th pResizableColumn style="width: 7rem">Цена В <p-sortIcon field="VPRICE"></p-sortIcon></th>
        <th pResizableColumn style="width: 5rem">До <p-sortIcon field="STOCKBE"></p-sortIcon></th>
        <th pResizableColumn style="width: 5rem">Дебет <p-sortIcon field="INCOME"></p-sortIcon></th>
        <th pResizableColumn style="width: 5rem">Кредит <p-sortIcon field="OUTCOME"></p-sortIcon></th>
        <th pResizableColumn style="width: 5rem">После <p-sortIcon field="STOCKAF"></p-sortIcon></th>

        <th pResizableColumn style="width: 8%">Юрлицо <p-sortIcon field="LOCCOMP"></p-sortIcon></th>
        <th pResizableColumn style="width: 5rem">До <p-sortIcon field="LCSTOCKBE"></p-sortIcon></th>
        <th pResizableColumn style="width: 5rem">После <p-sortIcon field="LCSTOCKAF"></p-sortIcon></th>

        <th pResizableColumn style="width: 7%">Примечание <p-sortIcon field="DOCNOTE1"></p-sortIcon></th>
        <th pResizableColumn style="width: 6%">Информация <p-sortIcon field="DOCNOTE2"></p-sortIcon></th>
      </tr>
      <tr>
        <th resizableColumns style="width: 3rem">...</th>
        <th style="overflow: visible !important; ">
          <p-multiSelect #dst [options]="docTypes" placeholder="Все документы" (onChange)="onDocTypeChange($event)" [(ngModel)]="selectedDocTypes"
                         styleClass="p-column-filter p-dropdown-filter-style" optionLabel="DOCNAME1" [maxSelectedLabels]="1" optionValue="DOCTYPEID"
                         emptyFilterMessage="Не найдено" selectedItemsLabel="{0} типов выбрано" tooltip="Фильтр по выбранным типам документов"></p-multiSelect>
        </th>
        <th resizableColumns style="overflow: visible !important; ">
          <input pInputText type="text" (input)="tosTable.filter($event.target.value, 'DOCNUMBER', 'contains')" placeholder="Поиск"
                 [(ngModel)]="tosRowNumberFilter"
                 class="p-column-filter p-dropdown-filter-style">
        </th>
        <th resizableColumns >
        </th>
        <th resizableColumns style="overflow: visible !important; ">
          <input pInputText type="text" (input)="tosTable.filter($event.target.value, 'DEPNAME', 'contains')" placeholder="Поиск" [(ngModel)]="tosRowDepFilter"
                 class="p-column-filter p-dropdown-filter-style">
        </th>
        <th resizableColumns style="overflow: visible !important; ">
          <input pInputText type="text" (input)="tosTable.filter($event.target.value, 'CLINAME', 'contains')" placeholder="Поиск" [(ngModel)]="tosRowCliFilter"
                 class="p-column-filter p-dropdown-filter-style">
        </th>
        <th resizableColumns >
          <input pInputText type="text" (input)="tosTable.filter($event.target.value, 'VPRICE', 'gt')" [(ngModel)]="tosRowVPriceFilter"
                 placeholder="Больше" class="p-column-filter p-dropdown-filter-style" pTooltip="Больше указанного числа, или равно 0, если 0" tooltipPosition="top">
        </th>
        <th resizableColumns >
          <input pInputText type="text" (input)="tosTable.filter($event.target.value, 'STOCKBE', 'gt')" [(ngModel)]="tosRowStockBeFilter"
                 placeholder="Больше" class="p-column-filter p-dropdown-filter-style" pTooltip="Больше указанного числа, или равно 0, если 0" tooltipPosition="top">
        </th>
        <th resizableColumns>
          <input pInputText type="text" (input)="tosTable.filter($event.target.value, 'INCOME', 'gt')" [(ngModel)]="tosRowIncomeFilter"
                 placeholder="Больше" class="p-column-filter p-dropdown-filter-style" pTooltip="Больше указанного числа, или равно 0, если 0" tooltipPosition="top">
        </th>
        <th resizableColumns >
          <input pInputText type="text" (input)="tosTable.filter($event.target.value, 'OUTCOME', 'gt')" [(ngModel)]="tosRowOutcomeFilter"
                 placeholder="Больше" class="p-column-filter p-dropdown-filter-style" pTooltip="Больше указанного числа, или равно 0, если 0" tooltipPosition="top">
        </th>
        <th resizableColumns >
          <input pInputText type="text" (input)="tosTable.filter($event.target.value, 'STOCKAF', 'gt')" [(ngModel)]="tosRowStockAfFilter"
                 placeholder="Больше" class="p-column-filter p-dropdown-filter-style" pTooltip="Больше указанного числа, или равно 0, если 0" tooltipPosition="top">
        </th>
        <th resizableColumns >
          <input pInputText type="text" (input)="tosTable.filter($event.target.value, 'LOCCOMP', 'contains')" placeholder="Поиск" [(ngModel)]="tosRowLocCompFilter"
                 class="p-column-filter p-dropdown-filter-style">
        </th>
        <th resizableColumns >
          <input pInputText type="text" (input)="tosTable.filter($event.target.value, 'LCSTOCKBE', 'gt')" [(ngModel)]="tosRowLcStockBeFilter"
                 placeholder="Больше" class="p-column-filter p-dropdown-filter-style" pTooltip="Больше указанного числа, или равно 0, если 0" tooltipPosition="top">
        </th>
        <th resizableColumns >
          <input pInputText type="text" (input)="tosTable.filter($event.target.value, 'LCSTOCKAF', 'gt')" [(ngModel)]="tosRowLcStockAfFilter"
                 placeholder="Больше" class="p-column-filter p-dropdown-filter-style" pTooltip="Больше указанного числа, или равно 0, если 0" tooltipPosition="top">
        </th>
        <th resizableColumns >
          <input pInputText type="text" (input)="tosTable.filter($event.target.value, 'DOCNOTE1', 'contains')" placeholder="Поиск" [(ngModel)]="documentNote1Filter"
                 class="p-column-filter p-dropdown-filter-style">
        </th>
        <th resizableColumns >
          <input pInputText type="text" (input)="tosTable.filter($event.target.value, 'DOCNOTE2', 'contains')" placeholder="Поиск" [(ngModel)]="documentNote2Filter"
                 class="p-column-filter p-dropdown-filter-style">
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-tosRow let-expanded="expanded">
      <tr [pSelectableRow]="tosRow"
          [class.proformadoc]="(tosRow.DOCTYPE == 12)"
          [class.inorderdoc]="(tosRow.DOCTYPE == 2)"
          [class.banktransferdoc]="(tosRow.DOCTYPE == 9)"
          [class.purchorderdoc]="(tosRow.DOCTYPE == 10)"
          [class.yellowdoc]="(tosRow.DOCTYPE == 14)"
          [class.specdoc]="(tosRow.DOCTYPE == 7)"
          [class.shiporderdoc]="(tosRow.DOCTYPE == 4)"
          [class.invoicedoc]="(tosRow.DOCTYPE == 1)">
        <td>
          <button type="button" pButton pRipple [pRowToggler]="tosRow"
                  class="p-button-text p-button-rounded p-button-plain"
                  [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
        </td>
        <td >{{tosRow.DOCNAME}}</td>
        <td ><a [routerLink]="['/edit-document', tosRow.DOCTYPE, tosRow.DOCID]">{{tosRow.DOCNUMBER}}</a></td>
        <td >{{tosRow.DOCDATE | date:'dd.MM.yyyy' }}</td>

        <td >{{tosRow.DEPNAME}}</td>
        <td ><a [routerLink]="['/edit-client', tosRow.DOCCLIENTSID]">{{tosRow.CLINAME}}</a></td>

        <td style="text-align: right">{{tosRow.VPRICE | number:'1.2-2' }}</td>
        <td style="text-align: right">{{tosRow.STOCKBE | number:'1.0-2' }}</td>
        <td style="text-align: right">{{tosRow.INCOME | number:'1.2-2' }}</td>
        <td style="text-align: right">{{tosRow.OUTCOME | number:'1.2-2'  }}</td>
        <td style="text-align: right">{{tosRow.STOCKAF | number:'1.0-2'  }}</td>

        <td >{{tosRow.LOCCOMP}}</td>
        <td style="text-align: right">{{tosRow.LCSTOCKBE | number:'1.0-2' }}</td>
        <td style="text-align: right">{{tosRow.LCSTOCKAF | number:'1.0-2' }}</td>

        <td ><input pInputText type="text" [(ngModel)]="tosRow.DOCNOTE1" [style]="{'width':'100%'}" readonly alt="{{tosRow.DOCNOTE1}}"></td>
        <td ><input pInputText type="text" [(ngModel)]="tosRow.DOCNOTE2" [style]="{'width':'100%'}" readonly alt="{{tosRow.DOCNOTE2}}"></td>
      </tr>
    </ng-template>

    <ng-template pTemplate="rowexpansion" let-tosRow>
      <tr>
        <td colspan="16">
          <div class="p-p-2">
            <app-document-content-table [selectedDocumentId]="tosRow.DOCID" [showFooterTotal]="true"></app-document-content-table>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr style="height: 15vw">
        <td colspan="16">Документов не найдено</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- ************************************************************************************** -->

<ng-template #toLoading>
  <p>Оборотная ведомость загружается...</p>
</ng-template>
